import React from 'react';
import VideoOverlayStyles from './styles';

const VideoOverlay = ({ opacity, height }) => <VideoOverlayStyles opacity={opacity} height={height} />;

export default VideoOverlay;
